import { getVirtualTourType } from '@pkgs/components/utils/propertyCardUtils';

import { useDefaultSearchResultCardContext } from './SearchResultCardProvider';
import { VtourIcon, VtourIconContainer } from '../VtourIcon/VtourIcon';

export const SearchResultCardVtourIcon = () => {
  const {
    listing: { videoUrlNormalized, vtourUrlNormalized },
  } = useDefaultSearchResultCardContext();

  const vTourType = getVirtualTourType(vtourUrlNormalized, videoUrlNormalized);

  if (!vTourType) return null;

  return (
    <VtourIconContainer data-testid="search-components_result-card_virtual-tour-icon">
      <VtourIcon type={vTourType} />
    </VtourIconContainer>
  );
};
